
import Vue, { PropType } from 'vue'
import { Tablet, TabletStatus } from '@/models'
import moment from 'moment'

function convertTabletStatus(rawTabletStatus?: TabletStatus): string {
  switch (rawTabletStatus) {
    case TabletStatus.UNINITIALIZED:
      return '未初期化'
    case TabletStatus.RUNNING:
      return '稼動'
    case TabletStatus.SUSPENDED:
      return '停止'
    default:
      return '不明'
  }
}

export default Vue.extend({
  name: 'TabletListItem',

  props: {
    tablet: Object as PropType<Tablet>
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin"
    },

    statusText(): string {
      return convertTabletStatus(this.tablet?.details?.status)
    },

    statusTextClass(): string {
      return [
        TabletStatus.UNKNOWNTABLETSTATUS,
        TabletStatus.UNINITIALIZED,
        TabletStatus.SUSPENDED,
      ].includes(this.tablet?.details?.status || TabletStatus.UNKNOWNTABLETSTATUS) ? 'red' : ''
    },

    checkedTimingText(): string {
      if (!this.tablet?.details?.latestDateTime) return 'なし'
      return moment(this.tablet?.details?.latestDateTime).format('YYYY-MM-DD(HH:mm:ss)')
    },

    deletable(): boolean {
      return this.tablet?.details?.status !== TabletStatus.RUNNING
    },

    deleteButtonClassText(): string {
      return this.deletable ? 'hover-circle' : 'disabled'
    }
  },

  methods: {
    showDeleteScreen(): void {
      if (!this.deletable) {
        return
      }
      const companyId = this.$auth.companyId
      const tabletId = this.tablet.id
      if (!companyId || !tabletId) {
        return
      }
      this.$router.push({
        name: 'admin-company-tablet-delete',
        params: {
          companyId: companyId,
          tabletId: tabletId
        }
      })
    }
  }
})
